import React from "react"
import { Card, Col, Row, Spinner } from "reactstrap"
import { TIME_FORMATS } from "constants/index"
import moment from "moment"
import { SaveButton } from "components/Buttons"

const BookingDetailModal = ({
  bookingDetails,
  editBookingHandler,
  cancelBookingHandler,
  refundBookingHandler,
}) => {
  return (
    <React.Fragment>
      <Row className="mb-2">
        <span>Calendar: {bookingDetails?.booking_type?.calendar?.name}</span>
      </Row>
      <Card
        style={{ backgroundColor: "#ededed", borderRadius: "5px" }}
        className="p-3"
      >
        <Row>
          <span>
            <label>{bookingDetails?.booking_type?.name}</label>
          </span>
        </Row>
        <Row>
          <span>{bookingDetails?.start_date}</span>
        </Row>
        <Row>
          <span>
            <label>Location:</label> {bookingDetails?.booking_type?.location}
          </span>
        </Row>

        <Row>
          <span>
            <label>Name: </label> {bookingDetails?.user_name}
          </span>
        </Row>
        <Row>
          <span>
            <label>Email: </label> {bookingDetails?.user_email}
          </span>
        </Row>
        <Row>
          <span>
            <label>Phone: </label> {bookingDetails?.phone}
          </span>
        </Row>
        <Row>
          <span>
            <label>Booked by: </label> {bookingDetails?.creator?.display_name}{" "}
            {`(${bookingDetails?.creator?.display_email})`}
          </span>
        </Row>
        <Row>
          <span>
            <label>Date booked: </label>
            {moment(bookingDetails?.created_at?.date).format(
              TIME_FORMATS(
                moment().diff(moment(bookingDetails?.created_at?.date), "days")
              ).DATETIME
            )}
          </span>
        </Row>

        <Row>
          <span>
            <label>Notes: </label> {bookingDetails?.notes}
          </span>
        </Row>
        <Row>
          <span>
            <label>Booked Seats: </label> {bookingDetails?.booked_seats}
          </span>
        </Row>
        {bookingDetails?.cancelled_seats > 0 && (
          <Row>
            <span>
              <label>Cancelled Seats: </label> {bookingDetails?.cancelled_seats}
            </span>
          </Row>
        )}
        {bookingDetails?.status == 0 && bookingDetails?.cancellation_notes && (
          <Row>
            <span>
              <label>Cancellation Notes: </label>{" "}
              {bookingDetails?.cancellation_notes}
            </span>
          </Row>
        )}
      </Card>
      <Row>
        <label>Payment Details</label>
      </Row>
      {!bookingDetails?.stripe_payment &&
      (!bookingDetails?.booking_type?.price ||
        bookingDetails?.booking_type?.price == 0) ? (
        <Row>
          <Col>
            <span>Free</span>
          </Col>
        </Row>
      ) : (
        !!bookingDetails?.stripe_payment && (
          <>
            {bookingDetails?.stripe_payment?.connected_account_changed &&
              !!bookingDetails?.stripe_payment &&
              ((!!bookingDetails?.stripe_payment?.refunded_amount &&
                bookingDetails?.stripe_payment?.partial_refund) ||
                !bookingDetails.stripe_payment.refunded_amount) && (
                <p>
                  !!! A refund can not be done from the dashboard because the
                  connected account has been changed.
                  <br />
                  You can do the refund only from the stripe account(id:{" "}
                  <b>{bookingDetails?.stripe_payment?.connected_account_id}</b>
                  ), where the payment was done.
                </p>
              )}
            {!!bookingDetails?.stripe_payment &&
              !!bookingDetails?.stripe_payment?.refunded_amount && (
                <b>
                  {bookingDetails?.stripe_payment?.partial_refund && (
                    <span>PARTIAL </span>
                  )}
                  <span>REFUNDED </span>
                  <span>
                    ($
                    {bookingDetails?.stripe_payment?.refunded_amount / 100})
                  </span>
                </b>
              )}
            {!!bookingDetails?.stripe_payment &&
              bookingDetails?.stripe_payment?.refund_status == 3 && (
                <span>
                  <b>REFUNDING</b>
                </span>
              )}
            <br />
            Order ID: {bookingDetails?.order_id}
            <br />
            Date Ordered:{" "}
            {moment(bookingDetails?.created_at?.date).format(
              TIME_FORMATS(
                moment().diff(moment(bookingDetails?.created_at?.date), "days")
              ).DATETIME
            )}
            <br />
            Order Total: ${bookingDetails?.stripe_payment?.amount / 100}
            <br />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "start",
              }}
            >
              <div>Billing: </div>&nbsp;
              <div>
                <span>{bookingDetails?.stripe_payment?.billing_name}</span>
                <br />
                <span>
                  {bookingDetails?.stripe_payment?.billing_line1}{" "}
                  {bookingDetails?.stripe_payment?.billing_line2}
                </span>
                <br />
                <span>
                  {bookingDetails?.stripe_payment?.billing_city}{" "}
                  {bookingDetails?.stripe_payment?.billing_state}{" "}
                  {bookingDetails?.stripe_payment?.billing_country}
                  {bookingDetails?.stripe_payment?.postal_code}
                </span>
              </div>
            </div>
            <div>
              Payment Method:&nbsp;
              {bookingDetails?.stripe_payment?.payment_method == 1 && (
                <span>
                  *** *** *** {bookingDetails?.stripe_payment.card_last4}
                </span>
              )}
              {bookingDetails?.stripe_payment?.payment_method == 2 && (
                <span>Apple Pay</span>
              )}
              {bookingDetails?.stripe_payment?.payment_method == 3 && (
                <span>Google Pay</span>
              )}
            </div>
            <br />
            {!!bookingDetails?.stripe_payment &&
              bookingDetails?.stripe_payment?.refunded_at && (
                <p>
                  <b>
                    Refunded at:{" "}
                    <span>
                      {moment(
                        bookingDetails?.stripe_payment?.refunded_at
                      ).format(
                        TIME_FORMATS(
                          moment().diff(
                            moment(bookingDetails?.stripe_payment?.refunded_at),
                            "days"
                          )
                        ).DATETIME
                      )}
                    </span>
                  </b>
                </p>
              )}
          </>
        )
      )}
      {!bookingDetails?.has_passed && (
        <Row className="justify-content-center">
          {bookingDetails?.status == 1 && (
            <Col xs="auto" className="my-1">
              <SaveButton
                type="button"
                content="Edit booking"
                onClick={editBookingHandler}
              />
            </Col>
          )}
          {bookingDetails?.status == 1 && (
            <Col xs="auto" className="my-1">
              <SaveButton
                type="button"
                content="Cancel booking"
                color="danger"
                onClick={cancelBookingHandler}
              />
            </Col>
          )}
          {!!bookingDetails?.stripe_payment &&
            !bookingDetails?.stripe_payment?.connected_account_changed &&
            !bookingDetails?.stripe_payment?.full_refund && (
              <Col xs="auto" className="my-1">
                <SaveButton
                  type="button"
                  content="Refund booking"
                  color="danger"
                  onClick={refundBookingHandler}
                />
              </Col>
            )}
        </Row>
      )}
    </React.Fragment>
  )
}

export default BookingDetailModal
